import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { browserHistory } from 'react-router';

// Actions
import { deleteDraft, deletePublished } from 'cards/actions/draftsAndOrdersRedesignActions';
import { deleteOrder } from 'cards/actions/digitalOrdersActions';
import { deleteDraft as deleteDigitalDraft } from 'cards/actions/digitalDraftsActions';
import { hideModal } from 'cards/actions/modalActions';
import { toastsActions } from '@zola-helpers/client';

// Components
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

// Assets
import TrashBin from 'assets/images/digitalSaveTheDate/trashbin-circle.svg';

// Utils
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { deleteProject, handleDeleteProjectError } from '../../../../actions/draftsActions';
import { trackEvent } from '../../../../../util/trackingHelper';

import styles from '../Digital/styles.module.less';

export type DeleteProjectModalProps = {
  cardType: string;
  draftMedium: string;
  dstdIsPublished?: boolean;
  publishedAt?: string;
  projectUUID: string;
  redirect?: boolean;
};

const DeleteProjectModal: FC<DeleteProjectModalProps> = ({
  cardType,
  draftMedium,
  dstdIsPublished,
  publishedAt,
  projectUUID,
  redirect,
}) => {
  const dispatch = useDispatch();

  const handleDeleteProject = () => {
    if (draftMedium === 'DIGITAL') {
      trackEvent('CTA Clicked', {
        business_unit: BUSINESS_UNIT.DIGITAL_SAVE_THE_DATE,
        cta_type: 'BUTTON',
        cta: dstdIsPublished ? 'DELETE_PUBLISHED' : 'DELETE_DRAFT',
      });
      if (publishedAt) {
        (dispatch(deleteOrder(projectUUID)) as any)
          // remove published from new draftsAndOrdersRedesign section of store
          .then(() => dispatch(deletePublished(projectUUID)))
          .then(() => dispatch(hideModal()))
          .then(() => dispatch(toastsActions.positive({ headline: 'Published Card Deleted!' })))
          .catch((error: any) => console.log(error));
      } else {
        (dispatch(deleteDigitalDraft(projectUUID)) as any)
          // remove draft from new draftsAndOrdersRedesign section of store
          .then(({ payload }: { payload: any }) =>
            dispatch(deleteDraft(payload.projectUUID, draftMedium, cardType))
          )
          .then(() => dispatch(hideModal()))
          .then(() => dispatch(toastsActions.positive({ headline: 'Draft Deleted!' })))
          .catch((error: any) => console.log(error));
      }
    } else {
      trackEvent('CTA Clicked', {
        business_unit: BUSINESS_UNIT.INVITATIONS,
        cta_type: 'BUTTON',
        cta: 'DELETE_DRAFT',
      });
      (dispatch(deleteProject(projectUUID)) as any)
        // remove draft from new draftsAndOrdersRedesign section of store
        .then(({ payload }: { payload: any }) =>
          dispatch(
            deleteDraft(
              payload.projectUUID,
              draftMedium,
              cardType === 'DETAILS' ? 'ENCLOSURE' : cardType
            )
          )
        )
        .then(() => dispatch(hideModal()))
        .then(() => dispatch(toastsActions.positive({ headline: 'Draft Deleted!' })))
        .catch((error: any) => dispatch(handleDeleteProjectError(error)));
    }
    if (redirect) {
      browserHistory.push(`/wedding-planning/projects`);
    }
    dispatch(hideModal());
  };

  const dstdType = dstdIsPublished ? 'published card' : 'draft';

  return (
    <div className={styles.container}>
      <img src={TrashBin} alt="Trash bin" />
      <div className={styles.header}>Delete this {dstdType}?</div>
      <div className={styles.content}>
        <div>We&apos;re just checking. This action can&apos;t be undone!</div>
      </div>
      <div className={styles.buttonContainer}>
        <ButtonV2 onClick={() => dispatch(hideModal())} variant="secondary">
          No, Keep
        </ButtonV2>
        <ButtonV2 onClick={handleDeleteProject} className={styles.buttonSpacing}>
          Yes, Delete
        </ButtonV2>
      </div>
    </div>
  );
};

export default DeleteProjectModal;
